import React from 'react';
import clsx from 'clsx';

import type { SectionProps } from './Section.types';

export const Section = React.forwardRef<HTMLElement, SectionProps>(
  (
    {
      as: Component = 'div',
      type,
      classNames = [],
      children,
      theme,
      testId,
      ...restProps
    },
    ref
  ): JSX.Element => (
    <Component
      ref={ref}
      className={clsx(
        {
          section: type !== 'none',
          section_l: type === 'large',
          section_xl: type === 'xlarge',
        },
        ...classNames
      )}
      data-theme={theme}
      data-testid={testId}
      {...restProps}
    >
      {children}
    </Component>
  )
);

Section.displayName = 'Section';
